var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.series[0].data.length > 0)?_c('vue-apex-charts',{attrs:{"type":"bar","height":_vm.heightSize,"options":_vm.chartOptions,"series":_vm.series}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }